import { useRedirectToMainApp } from '@packages/shared/core/common/hooks';

export const useLogin = () => {
  const { getLoginPath } = useRedirectToMainApp();

  return {
    getLoginPath,
  };
};
